import auth0 from 'auth0-js'
import store from '@/store'

export default class AuthService {
  constructor () {
    this.auth0 = new auth0.WebAuth({
      domain: process.env.VUE_APP_AUTH_CONFIG_DOMAIN,
      clientID: process.env.VUE_APP_AUTH_CONFIG_CLIENTID,
      redirectUri: process.env.VUE_APP_AUTH_CONFIG_CALLBACK,
      responseType: 'token id_token',
      audience: 'https://lumbre/api',
      scope: 'openid profile'
    })
  }

  login () {
    this.auth0.authorize()
  }

  logout () {
    // Para que el logout funcione en auth0 whitelistear la logout url en
    // https://auth0.com/docs/quickstart/spa/vuejs#configure-logout-urls
    // return this.auth0.logout({
    //   returnTo: window.location.origin
    // })
  }

  handleAuthentication () {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (authResult) {
          store.dispatch('notifications/initializeNotifications')
          resolve(authResult)
        } else {
          return reject(err)
        }
      })
    })
  }

  getUserInfo () {
    return new Promise((resolve, reject) => {
      this.auth0.client.userInfo(store.state.session.accessToken, (err, user) => {
        if (user) {
          resolve(user)
        } else {
          return reject(err)
        }
      })
    })
  }

  updateTokens () {
    return new Promise((resolve, reject) => {
      // https://auth0.com/docs/api-auth/tutorials/silent-authentication#renew-expired-tokens
      this.auth0.checkSession({}, (err, authResult) => {
        if (authResult) {
          resolve(authResult)
        } else {
          return reject(err)
        }
      })
    })
  }
}
